const howToPlaySteps = [
    {
      img: "step1", // or images.step1 if imported
      alt: "Map with a red pin location",
      title: "1. Pick Your Spot",
      description: "Explore the map and tap on a landmark that catches your eye.",
    },
    {
      img: "step2",
      alt: "Check-in icon with red pin and check mark",
      title: "2. Check In",
      description: "When you arrive, check in to unlock your quest. Choose between Time Travel or Space Travel.",
    },
    {
      img: "step3",
      alt: "Hourglass icon",
      title: "3. Time Travel",
      description: "Solve a riddle to journey through history and see how the landmark has changed over time.",
    },
    {
      img: "step4",
      alt: "Globe with orbit path",
      title: "4. Space Travel",
      description: "Answer a question to discover global lookalikes—some might be from your home country!",
    },
    {
      img: "step5",
      alt: "Treasure chest with pirate flag",
      title: "5. Complete the Challenge",
      description: "Finish both paths and you have officially conquered Stad Hunt Stockholm. You are now the Jack Sparrow of city explorers!",
    },
  ];
  
  export default howToPlaySteps;
  